module.exports = __webpack_public_path__ + "images/laurel-ecc0ca73241620c9296033a6ce5ff392.png";